import { isExpirationEnabled } from './isExpirationEnabled';

export const isExpired = (savedAt: number, ttlMs: number): boolean => {
    if (!isExpirationEnabled(ttlMs)) return false;

    return Date.now() - savedAt > ttlMs;
};
